module.exports = __webpack_public_path__ + "files/22f5538e33bc56330c3147c61f5f8949.png";